// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_leaderboard_your_team = /** @type {(inputs: {}) => string} */ () => {
	return `Your team`
};

const de_widget_leaderboard_your_team = /** @type {(inputs: {}) => string} */ () => {
	return `Ihr Team`
};

const es_widget_leaderboard_your_team = /** @type {(inputs: {}) => string} */ () => {
	return `Tu equipo`
};

const fr_widget_leaderboard_your_team = /** @type {(inputs: {}) => string} */ () => {
	return `Votre équipe`
};

const fi_widget_leaderboard_your_team = /** @type {(inputs: {}) => string} */ () => {
	return `Sinun joukkueesi`
};

const hi_widget_leaderboard_your_team = /** @type {(inputs: {}) => string} */ () => {
	return `आपकी टीम`
};

const ja_widget_leaderboard_your_team = /** @type {(inputs: {}) => string} */ () => {
	return `あなたのチーム`
};

const nl_widget_leaderboard_your_team = /** @type {(inputs: {}) => string} */ () => {
	return `Jouw team`
};

const pt_widget_leaderboard_your_team = /** @type {(inputs: {}) => string} */ () => {
	return `A sua equipa`
};

const ro_widget_leaderboard_your_team = /** @type {(inputs: {}) => string} */ () => {
	return `Echipa ta`
};

const th_widget_leaderboard_your_team = /** @type {(inputs: {}) => string} */ () => {
	return `ทีมของคุณ`
};

const ur_widget_leaderboard_your_team = /** @type {(inputs: {}) => string} */ () => {
	return `آپ کی ٹیم`
};

const zh_hant1_widget_leaderboard_your_team = /** @type {(inputs: {}) => string} */ () => {
	return `你的團隊`
};

const da_widget_leaderboard_your_team = /** @type {(inputs: {}) => string} */ () => {
	return `Dit hold`
};

const it_widget_leaderboard_your_team = /** @type {(inputs: {}) => string} */ () => {
	return `La tua squadra`
};

const vn_widget_leaderboard_your_team = /** @type {(inputs: {}) => string} */ () => {
	return `Đội của bạn`
};

const ko_widget_leaderboard_your_team = /** @type {(inputs: {}) => string} */ () => {
	return `당신의 팀`
};

const tr_widget_leaderboard_your_team = /** @type {(inputs: {}) => string} */ () => {
	return `Takımın`
};

const lv_widget_leaderboard_your_team = /** @type {(inputs: {}) => string} */ () => {
	return `Jūsu komanda`
};

const ar_widget_leaderboard_your_team = /** @type {(inputs: {}) => string} */ () => {
	return `فريقك`
};

const bs_widget_leaderboard_your_team = /** @type {(inputs: {}) => string} */ () => {
	return `Vaš tim`
};

const sl_widget_leaderboard_your_team = /** @type {(inputs: {}) => string} */ () => {
	return `Vaša ekipa`
};

const id_widget_leaderboard_your_team = /** @type {(inputs: {}) => string} */ () => {
	return `Tim Anda`
};

const sv_widget_leaderboard_your_team = /** @type {(inputs: {}) => string} */ () => {
	return `Ditt lag`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_leaderboard_your_team = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_leaderboard_your_team(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_leaderboard_your_team", locale)
	if (locale === "en") return en_widget_leaderboard_your_team(inputs)
	if (locale === "de") return de_widget_leaderboard_your_team(inputs)
	if (locale === "es") return es_widget_leaderboard_your_team(inputs)
	if (locale === "fr") return fr_widget_leaderboard_your_team(inputs)
	if (locale === "fi") return fi_widget_leaderboard_your_team(inputs)
	if (locale === "hi") return hi_widget_leaderboard_your_team(inputs)
	if (locale === "ja") return ja_widget_leaderboard_your_team(inputs)
	if (locale === "nl") return nl_widget_leaderboard_your_team(inputs)
	if (locale === "pt") return pt_widget_leaderboard_your_team(inputs)
	if (locale === "ro") return ro_widget_leaderboard_your_team(inputs)
	if (locale === "th") return th_widget_leaderboard_your_team(inputs)
	if (locale === "ur") return ur_widget_leaderboard_your_team(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_leaderboard_your_team(inputs)
	if (locale === "da") return da_widget_leaderboard_your_team(inputs)
	if (locale === "it") return it_widget_leaderboard_your_team(inputs)
	if (locale === "vn") return vn_widget_leaderboard_your_team(inputs)
	if (locale === "ko") return ko_widget_leaderboard_your_team(inputs)
	if (locale === "tr") return tr_widget_leaderboard_your_team(inputs)
	if (locale === "lv") return lv_widget_leaderboard_your_team(inputs)
	if (locale === "ar") return ar_widget_leaderboard_your_team(inputs)
	if (locale === "bs") return bs_widget_leaderboard_your_team(inputs)
	if (locale === "sl") return sl_widget_leaderboard_your_team(inputs)
	if (locale === "id") return id_widget_leaderboard_your_team(inputs)
	if (locale === "sv") return sv_widget_leaderboard_your_team(inputs)
	return "widget_leaderboard_your_team"
};